import Vue from 'vue'
import Vuex from 'vuex'

import CustomerDataService from '../api/customer-data'
const customerDataService = new CustomerDataService();

Vue.use(Vuex)

const state = {
  loggedIn: false,
  currentUser: null,
  orders: [],
  users: [],
  orderData: []
};

const mutations = {
  update_users (state, { users }){
    state.users = users;
  },

  update_orders (state, { orders }){
    state.orderData = orders;
  },

  set_current_user(state, { user }){
    state.currentUser = user;
  },

  set_current_orders(state, { orders }){
    state.orders = orders;
  }
};

const actions = {
  logIn({state, commit, dispatch}, {username, password}){
    return new Promise((resolve, reject)=>{
      customerDataService.login({ username, password })
        .then(data => {
          if(data){
            let user = data[0]
            // set logged in
            commit('set_current_user', { user });
            // load orders
            dispatch('loadOrders', { accountId: user.AccountId });
            resolve()
          } else reject()
          
        })
    })
  },

  loadOrders({state, commit}, { accountId, from, to, orderNumber }){
    return customerDataService.getOrders({ accountId, from, to, orderNumber })
      .then(data => {
        commit('set_current_orders', { orders: data });
      })
  }
};

const getters = {
  customerByAccountId: (state) => (accountId) => state.users.find(user => user.id === accountId),

  orders: (state) => state.orders
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js